<script setup lang="ts">
import InfoTooltip from '@/shared/ui/InfoTooltip/index';

const isShow = defineModel<boolean>({ default: false });

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['verification-tooltip', { _mobile: isMobile }]">
    <InfoTooltip
      v-model="isShow"
      :is-show-cross="false"
      class="verification-tooltip__tooltip"
    >
      <template #tooltip-content>
        <p class="verification-tooltip__text">
          Профиль проверен. Документы владельца аккаунта предоставлены и подтверждены.
        </p>
      </template>
    </InfoTooltip>
  </div>
</template>

<style lang="less">
.verification-tooltip {
  position: absolute;
  top: -62px;
  left: 5px;
  width: 238px;
  z-index: 990;
  text-align: left;

  &__tooltip {
    border-radius: @main-size;
    padding: @size-x3;
  }

  &__text {
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 600;
  }

  small {
    font-weight: 500;
  }

  &._mobile {
    width: 150px;
    left: -80px;
    top: -67px;
  }

  &._mobile &__text {
    font-size: @size-x3;
    line-height: @size-x4;
  }
}
</style>
